'use client'
import { IconButton as ChakraIconButton } from '@chakra-ui/react'
import { defineStyle, defineStyleConfig } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { IconButtonProps } from './IconButton.types'

const noBackground = defineStyle({
  border: 'none',
  background: 'none',
  icon: {
    color: 'blue.500',
  },

  '&:before': {
    content: '""',
    position: 'absolute',
    top: '0',
    left: '100%',
    width: '100%',
    height: '100%',
    opacity: '0',
    transition: 'all 550ms cubic-bezier(0.19, 1, 0.22, 1)',
  },
  '&:hover::before': {
    opacity: '1',
    left: '0',
    color: 'white',
    backgroundColor: 'blue.500',
    icon: {
      color: 'white',
    },
  },
})

export const iconButtonStyle = defineStyleConfig({
  variants: { noBackground },
})

export default forwardRef(function IconButton(
  props: IconButtonProps,
  ref: LegacyRef<HTMLButtonElement>
) {
  return <ChakraIconButton {...props} ref={ref} translate="no" />
})
